import LoginUtils from "./LoginUtils"

export const clone = (object) => {
    return JSON.parse(JSON.stringify(object));
}

export const readFile = async function readFile(file) {
    const reader = new FileReader()

    reader.readAsText(file, 'ISO-8859-1')

    return new Promise((resolve) => {
        reader.onload = function() {
            resolve(reader.result)
        }
    })
}

export const isString = (value) =>  (typeof value === 'string' || value instanceof String)

export const downloadPost = (url) => {
    
    let form = document.createElement('form')
    form.method = 'post'
    form.target = '_blank'
    form.action = process.env.VUE_APP_API_URL + url

    let tokenAccess = LoginUtils.getTokenAccess()
    
    if (tokenAccess)
    {
        // tokenAccess = `Bearer ${tokenAccess}`
        form.innerHTML = '<input type="hidden" name="access_token" value="' + tokenAccess + '">'
    }

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
}

export const getBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
}

export const convertFile = (strFile, type = "") => {
    
    var byteArray = new Uint8Array(strFile.length);
    
    for (var i = 0; i < strFile.length; i++) {
        byteArray[i] = strFile.charCodeAt(i);
    }

    return new Blob([byteArray], { type: type });
}


export const  isObject = (variable) => {   
    return variable !== null && typeof variable ==='object' && !Array.isArray (variable); 
}

export const replaceNotNumbers = (number) => {
    return number.replace(/\D/g,"");  
}

export const SMS = "SMS"
export const TOTP = "TOTP"

